module.exports = __webpack_public_path__ + "img/logo_fond_noir.3b56f688.png";